import { batchesApi } from "./batches";

export const {
  useGetBatchesQuery,
  useGetBatchQuery,
  useLazyGetBatchQuery,
  useLazyGetBatchesQuery,
  useGetStatusCountQuery,
  usePostChangeBatchWorkstationMutation,
  usePostForcePrepareCartMutation,
  usePostAssignCartMutation,
  usePostUnsuspendBatchMutation,
  useGetWaveProgressQuery
} = batchesApi;
